/**
The main entry point for the Stores.

Referenced by the page.stores.liquid template.
* */
import ReactDOM from 'react-dom';
import { Provider } from 'urql';
import graphqlClient from './utils/graphqlClient';
import Shops from './components/Shops';
import { jsx as _jsx } from "react/jsx-runtime";

function init() {
  var search = window.location.search; // eslint-disable-line

  var urlParams = new URLSearchParams(search);
  var client = graphqlClient(urlParams);
  var stores = document.getElementById('stores');
  ReactDOM.render( /*#__PURE__*/_jsx(Provider, {
    value: client,
    children: /*#__PURE__*/_jsx(Shops, {})
  }), stores);
}

init();